function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6a5d"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6a5d"] = parcelRequire;
}
parcelRequire.register("2l9Ur", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $1b453abb905410db$export$6503ec6e8aabbaf; }, function (v) { return $1b453abb905410db$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $1b453abb905410db$export$f7ad0328861e2f03; }, function (v) { return $1b453abb905410db$export$f7ad0328861e2f03 = v; });
var $1b453abb905410db$export$6503ec6e8aabbaf;
var $1b453abb905410db$export$f7ad0328861e2f03;
"use strict";
var $1b453abb905410db$var$mapping = {};
function $1b453abb905410db$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$1b453abb905410db$var$mapping[keys[i]] = pairs[keys[i]];
}
function $1b453abb905410db$var$resolve(id) {
    var resolved = $1b453abb905410db$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$1b453abb905410db$export$6503ec6e8aabbaf = $1b453abb905410db$var$register;
$1b453abb905410db$export$f7ad0328861e2f03 = $1b453abb905410db$var$resolve;

});

var $4af9bfbf496e16d1$exports = {};

(parcelRequire("2l9Ur")).register(JSON.parse('{"Fxw7D":"index.5b7d245a.js","5Blnn":"baboon.23379898.png"}'));


//# sourceMappingURL=index.b1e24ff9.js.map
